/*
================================================================
IMPORTS
================================================================
*/

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-csspointerevents-touchevents-setclasses !*/
!function(e,n,t){function o(e,n){return typeof e===n}function s(){var e,n,t,s,a,i,r;for(var l in c)if(c.hasOwnProperty(l)){if(e=[],n=c[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(s=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],r=i.split("."),1===r.length?Modernizr[r[0]]=s:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=s),f.push((s?"":"no-")+r.join("-"))}}function a(e){var n=u.className,t=Modernizr._config.classPrefix||"";if(p&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(o,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),p?u.className.baseVal=n:u.className=n)}function i(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):p?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function r(){var e=n.body;return e||(e=i(p?"svg":"body"),e.fake=!0),e}function l(e,t,o,s){var a,l,f,c,d="modernizr",p=i("div"),h=r();if(parseInt(o,10))for(;o--;)f=i("div"),f.id=s?s[o]:d+(o+1),p.appendChild(f);return a=i("style"),a.type="text/css",a.id="s"+d,(h.fake?h:p).appendChild(a),h.appendChild(p),a.styleSheet?a.styleSheet.cssText=e:a.appendChild(n.createTextNode(e)),p.id=d,h.fake&&(h.style.background="",h.style.overflow="hidden",c=u.style.overflow,u.style.overflow="hidden",u.appendChild(h)),l=t(p,e),h.fake?(h.parentNode.removeChild(h),u.style.overflow=c,u.offsetHeight):p.parentNode.removeChild(p),!!l}var f=[],c=[],d={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){c.push({name:e,fn:n,options:t})},addAsyncTest:function(e){c.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=d,Modernizr=new Modernizr;var u=n.documentElement,p="svg"===u.nodeName.toLowerCase();Modernizr.addTest("csspointerevents",function(){var e=i("a").style;return e.cssText="pointer-events:auto","auto"===e.pointerEvents});var h=d.testStyles=l,v=d._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];d._prefixes=v,Modernizr.addTest("touchevents",function(){var t;if("ontouchstart"in e||e.DocumentTouch&&n instanceof DocumentTouch)t=!0;else{var o=["@media (",v.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");h(o,function(e){t=9===e.offsetTop})}return t}),s(),a(f),delete d.addTest,delete d.addAsyncTest;for(var m=0;m<Modernizr._q.length;m++)Modernizr._q[m]();e.Modernizr=Modernizr}(window,document);

var Flickity = require('flickity');
import {formatMoney} from '@shopify/theme-currency/currency';
//import 'whatwg-fetch';
import serialize from 'form-serialize';

import {Ajaxinate} from 'ajaxinate';

/*
================================================================
VARS
================================================================
*/

var body = document.querySelector('body');

var siteMessage = document.querySelector('.site-message');
var noticeHeight;

var siteHeader = document.getElementById('site-header');
var siteHeaderTop = siteHeader.offsetTop;
var mobileNavToggle = document.querySelector('.js-mobile-nav-toggle');
var pageContainer = document.querySelector('#PageContainer');
var siteHeader = document.querySelector('.site-header');
var mobileNavContainer = document.querySelector('.mobile-nav-wrapper');
var mobileNav = document.querySelector('#MobileNav');
var sectionHeader = document.querySelector('#shopify-section-header');
var subNavToggleBtns = document.querySelectorAll('.js-toggle-submenu');

var desktopHoverNavs = document.querySelectorAll('.js-hover-nav');
var dropdownBoxToggleBtns = document.querySelectorAll('.dropdown-link');
var helpDialog = document.getElementById('help-overlay');

var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu',
    siteNoticeCollapsed: 'collapsed',
    sidebarActive: 'is--open',
    zoomIsOpen: 'product-zoom--open'
};



/*
================================================================
ACCESSIBILITY
================================================================
*/
var keyboardNav = false;
let lastFocus = document.querySelector('a');
let returnFocus;

(function () {
    'use strict';

    function keyboardFocus (e) {
        if (e.keyCode !== 9) {
            return;
        }

        switch (e.target.nodeName.toLowerCase()) {
            case 'input':
            case 'select':
            case 'textarea':
                break;
            default:
                document.documentElement.classList.add('keyboard-focus');
                document.removeEventListener('keydown', keyboardFocus, false);
                keyboardNav = true;
        }
    }

    document.addEventListener('keydown', keyboardFocus, false);
})();

const focusableElements = document.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');



focusableElements.forEach(element => {
    element.addEventListener('focus', (event) => {
        lastFocus = event.target;
    });
});


/*
================================================================
KLAVIYO
================================================================
*/


// const newsletterDialog = document.querySelector('.newsletter-popup');
// let shownPopup = false;
// // check to see if cookie is there and set value
// var cookieValue = document.cookie;
// if (cookieValue.indexOf('news_pop=') >= 0) {
//   var cookieData = cookieValue.split(';');
//   for(var i=0; i<cookieData.length; i++) {
//     if (cookieData[i].indexOf('news_pop=') >= 0) {
//       var cookieValue = cookieData[i].split('=')[1];
//      shownPopup = cookieValue;
//     }
//   }
// }
// let timeout = 4000;
// let timer;

// // add listener to close popup

// newsletterDialog.addEventListener('click', function(event){
//     if(event.target.classList.contains('close-button') || event.target.classList.contains('active')){
//         closeNewsletter();
//     }
// })


// if(!shownPopup){
//     timer = setTimeout(() => {
//         openNewsletter()
//     }, timeout);
//     window.addEventListener('scroll', () => {
//         if (window.scrollY > window.innerHeight) {
//           if(!shownPopup){
//               openNewsletter()
//           }else{
//             //   console.log('seen')
//           }
//         }
//       });
// }

// function openNewsletter(){
//     returnFocus = lastFocus;
//     newsletterDialog.classList.add('active');
//     focusTrap(newsletterDialog, closeNewsletter);
//     shownPopup = true;
//     console.log(returnFocus);
//     document.cookie = "news_pop = true; max-age=86400; path=/";
// }

// function closeNewsletter(){
//     newsletterDialog.classList.remove('active');
//     returnfocushandler(returnFocus)
// }

function returnfocushandler(element){
    if(keyboardNav == true && element != null){
        returnFocus.focus();
    }
}


/*
================================================================
COOKIES
================================================================
*/

window.Shopify.loadFeatures([
    {
      name: 'consent-tracking-api',
      version: '0.1',
    }
  ],
  function(error) {
    if (error) {
      throw error;
    }
    initCookieBanner();
  });


let cookieAcceptAlls = document.querySelectorAll('.js-cookie-accept-all');

cookieAcceptAlls.forEach(element => {
    element.addEventListener('click', (event) => {
        handleAccept();
    });
});

function getBannerEl() {
    return document.getElementById('cookies-banner');
  }
  function hideBanner(res) {
    getBannerEl().style.display = 'none';
  }
  function showBanner() {
   getBannerEl().style.display = 'block';
  }
  function handleAccept(e) {
    window.Shopify.customerPrivacy.setTrackingConsent(true, hideBanner);
    document.addEventListener('trackingConsentAccepted',function() {
        // initGtag;
    });
  }
  function initCookieBanner() {
    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
    const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();
    if(!userCanBeTracked && userTrackingConsent === 'no_interaction') {
      showBanner();
    }else{
       
    }
  }

  const cookiePrefToggles = document.querySelectorAll('.js-cookie-prefs');
  const cookiePrefs = document.querySelector('.cookie-dialog-wrapper');
  const form = document.getElementById('cookie-settings-form');

  cookiePrefToggles.forEach(element => {
    element.addEventListener('click', (event) => {
        openCookiePrefs();
    });
});


  form.addEventListener('submit', function(event) {
      event.preventDefault();
      let preferences = document.getElementById('cookie_preferences').checked;
      let analytics = document.getElementById('cookie_analytics').checked;
      let marketing = document.getElementById('cookie_marketing').checked;
      if(analytics == false){
        document.cookie = "__kla_off=true; max-age=31536000; path=/";
      }
      window.Shopify.customerPrivacy.setTrackingConsent(
        {
          "analytics":    analytics,
          "marketing":    marketing,
          "preferences":  preferences,
          "sale_of_data": false
        },
        () => 
        // console.log(window.Shopify.customerPrivacy.currentVisitorConsent())
        closeCookiePrefs()
      );
  });

  cookiePrefs.addEventListener('click', function(event){
        if(event.target.classList.contains('close-button') || event.target.classList.contains('active')){
            closeCookiePrefs();
        }
    })


  function openCookiePrefs(){
      returnFocus = lastFocus;
      cookiePrefs.classList.add('active');
      focusTrap(cookiePrefs, closeCookiePrefs);
  }
  
  function closeCookiePrefs(){
    cookiePrefs.classList.remove('active');
    hideBanner();
    // console.log(window.Shopify.customerPrivacy.currentVisitorConsent())
    returnfocushandler(returnFocus)
  }
 
  function initGtag(){
    var script = document.createElement('script');
        script.async = true;
        script.src = "https://www.googletagmanager.com/gtag/js?id=G-1MF1XSBZ58";
        document.body.appendChild(script);
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-1MF1XSBZ58');
  }

  console.log(window.Shopify)
  
//   if(window.Shopify.customerPrivacy.userCanBeTracked()){
//     initGtag;
//   }

/*
================================================================
DIALOGS
================================================================
*/

const dialogButtons = document.querySelectorAll('.dialog-toggle');
const dialogs = document.querySelectorAll('.dialog-wrapper');

// console.log(dialogButtons);

dialogButtons.forEach(button => {
    button.addEventListener('click', event => {
        openDialog(event)
    });
});

dialogs.forEach(element => {
    element.addEventListener('click', event => {
        if(event.target.classList.contains('active') || event.target.classList.contains('close-button')){
            closeAllDialogs();
        }
    });
});


function openDialog(event){
    
    let target = event.target.dataset.target;
    console.log(event)
    target = document.getElementById(target);
    returnFocus = lastFocus;
    if(target.classList.contains('youtube-dialog-wrapper')){
        const iframe = target.querySelector('iframe');
        if (iframe) {
          iframe.src = iframe.dataset.src;
        }
    }
    target.classList.add('active');
    focusTrap(target, closeAllDialogs);
}

function closeAllDialogs(){
    dialogButtons.forEach(function(element) {
        closeDialog(element);
    })
}

function closeDialog(element){
    let target = element.dataset.target;
    target = document.getElementById(target);
    if(target.classList.contains('youtube-dialog-wrapper')){
        const iframe = target.querySelector('iframe');
        if (iframe) {
          iframe.src = "";
        }
    }
    target.classList.remove('active');
    returnfocushandler(returnFocus);
}




/*
================================================================
HELP BUTTON VIS
================================================================
*/

let target = document.querySelector('.site-footer--bottom');
let options = {
  root: null,
  rootMargin: '0px',
  threshold: 0.5
};

let observer = new IntersectionObserver(function(entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
        document.body.classList.add('hide-help');
    }else {
        document.body.classList.remove('hide-help');
    }
  });
}, options);

observer.observe(target);



/*
================================================================
VIDEOS
================================================================
*/

const autoVids = document.querySelectorAll('.autovideo');

autoVids.forEach(element => {
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initVid(entry.target);
            }else{
                pauseVid(entry.target);
            }
        });
    }, { threshold: [0.1] });
    observer.observe(element);
});

function initVid(el) {
    // console.log('pop '+ el);
      if(el.preload == 'auto'){
        //   console.log('already loaded')
          el.play();
      }else{
          console.log('initial load')
          setTimeout(() =>  el.play(), 100);
          el.addEventListener("error", () => console.log("error"));
          el.preload = 'auto';  
      }
  }

  function pauseVid(el) {
    // console.log('pause: ' + el)
    el.pause();
  }

/*
================================================================
YOUTUBE EMBEDS
================================================================
*/

const autoFrames = document.querySelectorAll('.autoiframe');

autoFrames.forEach(element => {
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initFrame(entry.target);
            }else{
                unFrame(entry.target);
            }
        });
    }, { threshold: [0.1] });
    observer.observe(element);
});

function initFrame(el) {
    // console.log('FRAME')
    if(el.src){
        // console.log('already loaded')
    }else{
        el.src = el.dataset.src
    }
}

function unFrame(el){
    // el.removeAttribute('src');
}

/*
================================================================
SITE NOTICE
================================================================
*/

const siteNotice = document.getElementById('site-notice');
let shownNotice = false;

cookieValue = document.cookie;

if (cookieValue.indexOf('notice_pop=') >= 0) {
    var cookieData = cookieValue.split(';');
    for(var i=0; i<cookieData.length; i++) {
        if (cookieData[i].indexOf('notice_pop=') >= 0) {
        var cookieValue = cookieData[i].split('=')[1];
        shownNotice = cookieValue;
        }
    }
}

if(siteNotice && !shownNotice){
    initSiteNotice();
}else{
    // console.log('wlwlw');
}

function initSiteNotice(){
    siteNotice.classList.add('active');
    const closeSiteNoticeButton = siteNotice.querySelector('button');
    closeSiteNoticeButton.addEventListener('click', closeSiteNotice);
}

function closeSiteNotice(){
    siteNotice.classList.remove('active');
    var date = new Date();
    date.setDate(date.getDate() + 3);
    document.cookie = "notice_pop = true; expires=" + date + "; path=/";
}






// UTILS //

function focusTrap(targetEl, closeFunction) {
    const focusableEls = targetEl.querySelectorAll('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select');
    const firstFocusableEl = focusableEls[0];
    const lastFocusableEl = focusableEls[focusableEls.length - 1];
    firstFocusableEl.focus();
  
    targetEl.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstFocusableEl) {
            e.preventDefault();
            lastFocusableEl.focus();
          }
        } else {
          if (document.activeElement === lastFocusableEl) {
            e.preventDefault();
            firstFocusableEl.focus();
          }
        }
      }
  
      if (e.key === 'Escape') {
        closeFunction();
      }
    });
  }


/*
================================================================
MOBILE NAVIGATION
================================================================
*/

var isTransitioning;
var activeSubNav;
var activeTrigger;
var menuLevel = 1;

if (mobileNavToggle) {
  mobileNavToggle.addEventListener('click', toggleMobileNav);
}

function toggleMobileNav() {
    var mobileNavIsOpen = mobileNavToggle.classList.contains(
      classes.mobileNavCloseIcon
    );

    if (mobileNavIsOpen) {
        closeMobileNav();
    } else {
        openMobileNav();
    }
}

function openMobileNav() {
    closeAllSidebars();
    var translateHeaderHeight = siteHeader.offsetHeight;
    mobileNavContainer.classList.add(classes.navOpen);
    body.classList.add('mobile-menu--open');
    mobileNavToggle.classList.add(classes.mobileNavCloseIcon);
    mobileNavToggle.classList.remove(classes.mobileNavOpenIcon);
    mobileNavToggle.setAttribute('aria-expanded', true);
    focusTrap(mobileNavContainer, closeMobileNav);
}

function closeMobileNav() {
    mobileNavContainer.classList.remove(classes.navOpen);
    body.classList.remove('mobile-menu--open');
    pageContainer.setAttribute('style', '');
    mobileNavToggle.classList.add(classes.mobileNavOpenIcon);
    mobileNavToggle.classList.remove(classes.mobileNavCloseIcon);
    mobileNavToggle.setAttribute('aria-expanded', false);
    setTimeout(function(){closeAllSubNavs()}, 500);
}





subNavToggleBtns.forEach(function(element) {
  element.addEventListener('click', toggleSubNav);

});

function toggleSubNav(event) {
    var toggleBtn = event.currentTarget;
    var subNavIsOpen = toggleBtn.classList.contains(classes.subNavActive);
    if (subNavIsOpen) {
        closeSubNav(toggleBtn);
    } else {
        openSubNav(toggleBtn);
    }
}

function openSubNav(target) {
    target.classList.add(classes.subNavActive);
    target.setAttribute('aria-expanded', true);
    target = target.getAttribute('data-target');
    var targetMenu = document.querySelector('.mobile-nav__dropdown[data-parent="' + target + '"]');
    var targetHeight = targetMenu.children[0].offsetHeight;
    targetMenu.classList.add('active');
    targetMenu.style.height = targetHeight + 'px';
}

function closeSubNav(target) {
    target.classList.remove(classes.subNavActive);
    target.setAttribute('aria-expanded', false);
    target = target.getAttribute('data-target');
    var targetMenu = document.querySelector('.mobile-nav__dropdown[data-parent="' + target + '"]');
    targetMenu.classList.remove('active');
    targetMenu.style.height = 0 + 'px';

}

function closeAllSubNavs(){
    subNavToggleBtns.forEach(function(element) {
        closeSubNav(element);
    }
)}



/*
================================================================
DESKTOP NAVIGATION
================================================================
*/

var desktopNavToggleBtns = document.querySelectorAll('.js-toggle-desktop-submenu');
var desktopSubNavs = document.querySelectorAll('.desktop-menu--dropdown');
var mainNavLInks = document.querySelectorAll('.main-nav-link');

// if (desktopNavToggleBtns) {
//     desktopNavToggleBtns.forEach(function(element) {
//       element.addEventListener('click', toggleDesktopSubNav);
//     });
// }

if (desktopNavToggleBtns) {
    desktopNavToggleBtns.forEach(function(element) {
      element.addEventListener('click', function(event){
        if( keyboardNav){
            event.preventDefault();
            console.log(keyboardNav)
            openDesktopSubNav(element)
        }else{
            // return
        }
      });
    });
}

if (desktopNavToggleBtns) {
    desktopNavToggleBtns.forEach(function(element) {
      element.addEventListener('mouseover', toggleDesktopSubNav);
    });
}

if (desktopSubNavs) {
    desktopSubNavs.forEach(function(element) {
      element.addEventListener('mouseleave', closeAllDesktopSubNavs);
    });
}

if (mainNavLInks) {
    mainNavLInks.forEach(function(element) {
      element.addEventListener('mouseover', closeAllDesktopSubNavs);
    });
}

function toggleDesktopSubNav(event) {
    var target = event.currentTarget.getAttribute('data-target');
    event.preventDefault();
    var toggleBtn = event.currentTarget;
    var subNavIsOpen = toggleBtn.classList.contains(classes.subNavActive);
    closeAllDesktopSubNavs();
    closeAllSidebars();
    if (subNavIsOpen) {
        closeDesktopSubNav(toggleBtn);
    } else {
        openDesktopSubNav(toggleBtn);
    }   
}

function openDesktopSubNav(target) {
    closeAllDesktopSubNavs();
    closeAllSidebars();
    siteHeader.classList.add(classes.subNavActive);
    body.classList.add('desktop-submenu--open');
    target.classList.add(classes.subNavActive);
    target.setAttribute('aria-expanded', true);
    target = target.getAttribute('data-target');
    var targetMenu = document.getElementById(target);
    targetMenu.classList.add('active');
    focusTrap(targetMenu, closeAllDesktopSubNavs);
    if(target == "searchBar" && keyboardNav){
        document.getElementById("searchBarInput").focus();
    }
}

function closeDesktopSubNav(target) {
    siteHeader.classList.remove(classes.subNavActive);
    target.classList.remove(classes.subNavActive);
    body.classList.remove('desktop-submenu--open');
    target.setAttribute('aria-expanded', false);
    target = target.getAttribute('data-target');
    var targetMenu = document.getElementById(target);
    targetMenu.classList.remove('active');
}

function closeAllDesktopSubNavs(){
    desktopNavToggleBtns.forEach(function(element) {
        closeDesktopSubNav(element);
    }
)}


/*
================================================================
AJAX INFINITE SCROLL
================================================================
*/


new Ajaxinate({
    container: '#InfiniteContainer',
    pagination: '#InfinitePagination',
    loadingText: 'Loading more...',
  });


/*
================================================================
DROPDOWN BOXES
================================================================
*/


if (dropdownBoxToggleBtns) {
    dropdownBoxToggleBtns.forEach(function(element) {
      element.addEventListener('click', toggleDropdownBox);
    });
}

function toggleDropdownBox(event) {
    event.preventDefault();
    var toggleBtn = event.currentTarget;
    // console.log(toggleBtn);
    var boxIsOpen = toggleBtn.classList.contains(classes.subNavActive);
    // console.log(boxIsOpen);
    closeAllDropdownBoxes();
    if (boxIsOpen) {
        removeFade();
        closeDropdownBox(toggleBtn);
    } else {
        openDropdownBox(toggleBtn);
    }
}

function openDropdownBox(target) {
    target.classList.add(classes.subNavActive);
    target.classList.remove('faded');
    target.setAttribute('aria-expanded', true);
    var targetBox = target.getAttribute('data-target');
    var targetMenu = document.getElementById(targetBox);
    targetMenu.classList.add(classes.subNavActive);
    var parent = target.closest('details');
    // console.log(parent);
    parent.open = true;
}

function closeDropdownBox(target) {
    siteHeader.classList.remove(classes.subNavActive);
    target.classList.remove(classes.subNavActive);
    target.setAttribute('aria-expanded', false);
    var targetBox = target.getAttribute('data-target');
    var targetMenu = document.getElementById(targetBox);
    targetMenu.classList.remove(classes.subNavActive);
    var parent = target.closest('details');
    // console.log(parent);
    parent.open = false;
}

function closeAllDropdownBoxes(){
    dropdownBoxToggleBtns.forEach(function(element) {
        element.classList.add('faded');
        closeDropdownBox(element);
    });
}

function removeFade(){
    dropdownBoxToggleBtns.forEach(function(element) {
        element.classList.remove('faded');
    });
}




/*
================================================================
REQUIRE TERMS ON PRODUCTS
================================================================
*/


const acceptTerms = document.getElementById('acceptTerms');
const addToCartTerms = document.querySelector('.terms-required');
const showTerms = document.getElementById('showTerms');
const terms = document.getElementById('terms');

if(acceptTerms != null){
    acceptTerms.addEventListener('click', (event) => {
        if (acceptTerms.checked){
            addToCartTerms.disabled = false;
        }else{
            addToCartTerms.disabled = true;
        }
    
    });
}

if(addToCartTerms != null){
    addToCartTerms.addEventListener('click', (event) => {
        if (acceptTerms.checked == false){
            // console.log('poo');
        }
    });
}

if(showTerms != null){
    showTerms.addEventListener('click', (event) => {
        terms.classList.remove('hide');
    });
}

/*
================================================================
CART STUFF
================================================================
*/

var cartItemCounter = document.querySelectorAll('.cart-count');
var addToCartBtns = document.querySelectorAll('.js-add-to-cart');
var cartMessageContainer = document.getElementById('cart-messages');
var cartDialog = document.getElementById('cart-overlay');
var cartDialogMessages = document.querySelectorAll('.cart-overlay-message');
var cartItems = document.getElementById('cart-items');
var cartTotal = document.getElementById('cart-total');
var cartPopup = document.getElementById('cart-popup');
var mask = document.querySelector('.mask');
var redirect = false;

const moneyFormat = '{{amount}}';

var cartMessages = {
    errorOne: "Please choose an option",
    errorTwo: "This item is sold out.",
    successOne: "Item added to your cart.",
    cartEmpty: "Your cart is currently empty.",
    itemRemoved: "Item Removed"
}

addToCartBtns.forEach((item) => {
    // console.log(item);
    if(item.classList.contains("redirect")){
        redirect = true;
    }
    item.addEventListener('click', (event) => {
        event.preventDefault();
        const formID = item.getAttribute('data-form');
        if(productFormValidate(formID) == true){
            addItemToCart(formID);
        }
        // console.log(productFormValidate(formID));
    });
});

 

function addItemToCart(form_id) {
    var items = $('#'+form_id).serialize();
    // console.log(items);
    if( items == ''){
        // console.log('no-id');
        productFormValidate(cartMessages.errorOne);
        cartMessageContainer.innerHTML = '<div class="add-to-cart-error status-label-red ">' + cartMessages.errorOne + '</div>';
    }else{
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: $('#'+form_id).serialize(),
          success: addToCartOk,
          error: function(xhr, status, error) {
            var err = eval("(" + xhr.responseText + ")");
            addToCartFail(err.description);
          }
       });
    }
}

function productFormValidate(formID){
    var result = true;
    var fields = document.querySelectorAll('#'+formID+' select');
    fields.forEach((item) => {
        if(item.value == ""){
            item.classList.add('error');
            cartMessageContainer.innerHTML = '<div class="add-to-cart-error status-label-red ">' + cartMessages.errorOne + '</div>';
            result = false;
        }else{
            item.classList.remove('error');
        }
    });
    return result;
}

function addToCartOk(){
    getCart();
    // if(redirect == true){
    //     window.location.replace("http://www.mollygoddard.com/cart");
    // }
}

function addToCartFail(message){
   cartMessageContainer.innerHTML = '<div class="add-to-cart-error status-label-red ">' + message + '</div>';
}

function updateCartNotices(itemAdded){
    cartMessageContainer.innerHTML = "";
    cartDialogMessages.forEach((item) => {
        item.innerHTML = 'Item Added: ' + itemAdded;
    });
}

function openCartDialog(){
    body.classList.add('sidebar--open');
    cartDialog.classList.add('is--open');
}

function closeCartDialog(){
    body.classList.remove('sidebar--open');
    cartDialog.classList.remove('is--open');
}

function showCartPopup(){
    cartPopup.classList.add('active');
    setTimeout(function(){cartPopup.classList.remove('active');}, 5000);
}

mask.addEventListener('click', closeCartDialog);
mask.addEventListener('click', closeAllDesktopSubNavs);
mask.addEventListener('click', closeMobileNav);



function getCart(){
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(data){renderCart(data)},
      error: function(xhr, status, error) {
        var err = eval("(" + xhr.responseText + ")");
        addToCartFail(err.description);
      }
   });
}

function renderCart(cart){
    renderCartTotals(cart);
    clearCart();
    updateCartNotices(cart.items[0].title);
    // console.log(cart);
    if(cart == ""){
        cartItems.innerHTML = cartMessages.cartEmpty;
    }else{
         cart.items.forEach((item, index) => {
            let itemVariant = item.variant_title;
            if (itemVariant === null) {
                itemVariant = '';
            }
            const cartSingleProduct = `
            <div class="cart-item" id="item-${item.variant_id}">
                <div class="cart-item-image" style="background-image: url(${item.image});"></div>
                <div class="cart-item-info">
                    <a href="${item.url}" class="cart-item-title">${item.product_title}</a>
                    <div class="cart-item-variant">${item.options_with_values[0].name}: ${itemVariant}</div>
                    <div class="cart-item-quantity">Quantity: ${item.quantity}</div>
                    <div class="cart-item-price">${currencySymbol}${
                        formatMoney(item.line_price, moneyFormat)
                    }</div>
                    <a class="remove-item" data-id="${item.variant_id}">Remove</a>
                </div>
            </div>
      `     ;
            cartItems.innerHTML += cartSingleProduct;
        });
    }
    const removeFromCart = document.querySelectorAll('.remove-item');
    removeFromCart.forEach((item, index) => {
        item.addEventListener('click', () => {
            const id = item.getAttribute('data-id');
            removeItem(id);
            document.getElementById('item-' + id).classList.add('is-invisible');
        });
    });
    if(window.innerWidth > 750){
        openCartDialog();
    }else{
        showCartPopup();
    }
}

function clearCart(){
    cartItems.innerHTML = "";
}

function removeItem(id){
    const quantity = 0;
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {'id': id, 'quantity': quantity},
      success:  function (data) {
        // console.log(data);
        cartDialogMessages.forEach((item) => {
            item.innerHTML = cartMessages.itemRemoved;
        });
        renderCartTotals(data);
      },
      error: function(xhr, status, error) {
        var err = eval("(" + xhr.responseText + ")");
        // console.log(error + status[0] + xhr[0]);
      }
   });
}

function renderCartTotals(cart){
    cartTotal.innerHTML = currencySymbol + formatMoney(cart.total_price, moneyFormat);
    var cartCount = cart.item_count;
    if(cartCount == 0){
        cartCount = "";
        cartDialog.classList.add('cart-overlay-empty');
        cartDialogMessages.forEach((item) => {
            item.innerHTML = cartMessages.cartEmpty;
        });
    }else{
        cartDialog.classList.remove('cart-overlay-empty');
    }
    cartItemCounter.forEach(function(element){
      element.innerText = cartCount;
      if(cartCount == ""){
          element.parentNode.classList.add('empty');
      }else{
          element.parentNode.classList.remove('empty');
      }
    });

}



/*
================================================================
SIDEBAR TOGGLE BUTTONS
================================================================
*/

var sidebarToggleButtons = document.querySelectorAll('.sidebar-toggle');
var sidebarCloseButtons = document.querySelectorAll('.js-sidebar-close');

if (sidebarToggleButtons) {
    sidebarToggleButtons.forEach(function(element) {
      element.addEventListener('click', toggleSidebar);
    });
}

if(sidebarCloseButtons){
    sidebarCloseButtons.forEach(function(element) {
        // console.log(element);
        element.addEventListener('click', closeAllSidebars);
    });
}


function toggleSidebar(event) {
    var toggleBtn = event.currentTarget;
    var sidebarIsOpen = toggleBtn.classList.contains(classes.sidebarActive);
    closeAllSidebars();
    if (sidebarIsOpen) {
        closeSidebar(toggleBtn);
    } else {
        openSidebar(toggleBtn);
    }
}

function openSidebar(target) {
    body.classList.add('sidebar--open');
    target.classList.add('is--open');
    target.setAttribute('aria-expanded', true);
    var targetId = target.getAttribute('data-target');
    var targetSidebar = document.getElementById(targetId);
    targetSidebar.classList.add(classes.sidebarActive);
    focusTrap(targetSidebar, function(){closeSidebar(targetSidebar)});
    // console.log(targetSidebar);
}

function closeSidebar(target) {
    console.log(target)
    body.classList.remove('sidebar--open');
    target.classList.remove(classes.sidebarActive);
    target.setAttribute('aria-expanded', false);
    var targetId = target.getAttribute('data-target');
    var targetSidebar = document.getElementById(targetId);
    targetSidebar.classList.remove(classes.sidebarActive);
}

function closeAllSidebars(){
    closeMobileNav();
    sidebarToggleButtons.forEach(function(element) {
        console.log(element)
        closeSidebar(element);
    });
}

mask.addEventListener('click', closeAllSidebars);



/*
================================================================
CUSTOMER ADDRESSES
================================================================
*/


document.querySelectorAll('.address-delete-form').forEach(deleteForm => {
  deleteForm.addEventListener('submit', event => {
    const confirmMessage = event.target.getAttribute('data-confirm-message');
    if (
      !window.confirm(
        confirmMessage || 'Are you sure you wish to delete this address?'
      )
    ) {
      event.preventDefault();
    }
  });
});



/*
================================================================
IMAGE ZOOM 
================================================================
*/


var imageZoomToggle = document.querySelectorAll('.image-zoom-toggle');
var imageZoomContainer = document.getElementById('image-zoom-container');


if (imageZoomToggle) {
    imageZoomToggle.forEach(function(element) {
      element.addEventListener('click', toggleZoom);
    });
}

function toggleZoom(event) {
    var image = event.currentTarget;
    var zoomIsOpen = body.classList.contains(classes.zoomIsOpen);
    if (zoomIsOpen) {
        closeZoom();
    } else {
        openZoom(image);
    }
}

function openZoom(image) {
    if(window.innerWidth > 750){
        var targetID = 'zoom-' + image.getAttribute('id');
        var target = document.getElementById(targetID);
        body.classList.add(classes.zoomIsOpen);
        imageZoomContainer.classList.add(classes.zoomIsOpen);
        imageZoomContainer.addEventListener('load', function(e){
            target.scrollIntoView();
            // console.log(e.target, 'image loaded');
        }, true);
        target.scrollIntoView();
    }
}

function closeZoom(target) {
    body.classList.remove(classes.zoomIsOpen);
    imageZoomContainer.classList.remove(classes.zoomIsOpen);
}


/*
================================================================
PASSWORD RECOVERY PAGE
================================================================
*/
let recoveryFormVisible = false;
const recoverLink = document.getElementById('recoverLink');
const recoveryForm = document.getElementById('RecoverPasswordForm');
const loginForm = document.getElementById('loginForm');
const cancelLink = document.getElementById('recoverCancelLink');

if(recoverLink != null){
    recoverLink.addEventListener('click', toggleRecoveryForm);
}
if(cancelLink != null){
    cancelLink.addEventListener('click', toggleRecoveryForm);
}

function toggleRecoveryForm(){
    if(recoveryFormVisible == false){
        // console.log(loginForm);
        loginForm.style.display = "none";
        recoveryForm.style.display = "block";
        recoveryFormVisible = true;
    }else{
        console.log(recoveryForm);
        loginForm.style.display = "block";
        recoveryForm.style.display = "none";
        recoveryFormVisible = false;  
    }
}